export const DIMENSION_CATEGORY_KEYS = {
  eco: {
    content: 'content',
    user: 'user',
    device: 'device',
    geo: 'geo',
    screen: 'screen',
    events: 'events',
    network: 'network',
    errors: 'errors',
    page: 'page',
    event_tags: 'event_tags',
    global_tags: 'global_tags',
    campaign: 'campaign',
  },
};

export const dimensionsCategory: Record<string, Record<string, string>> = {
  EI: {
    content: 'Content', // represents both common and ei dimensions
    ai: 'Ad',
    geo: 'Geo',
    device: 'Device',
  },
  AI: {
    ai: 'Ad',
    geo: 'Geo',
    device: 'Device',
  },
  APP: {
    content: 'App',
    user: 'User',
    device: 'Device',
    geo: 'Geo & ISP',
    screen: 'Screen (Mobile)',
    [DIMENSION_CATEGORY_KEYS.eco.network]: 'Network Request',
    [DIMENSION_CATEGORY_KEYS.eco.events]: 'Events',
    errors: 'Errors',
    page: 'Page (Web)',
    [DIMENSION_CATEGORY_KEYS.eco.campaign]: 'UTM Parameters (Web)',
    // custom: 'Custom',
    event_tags: 'Event Tags',
    global_tags: 'Global Tags',
    flow: 'Flow',
    frustration_signal: 'Frustration Signal',
  },
  ODP: {
    custom: 'Custom',
  },
};

export const dimensionsCategoryOrder: Record<string, string[]> = {
  EI: ['content', 'device', 'geo', 'ai'],
  AI: ['ai', 'device', 'geo'],
  APP: [
    'content',
    'user',
    'device',
    'geo',
    'page',
    'campaign',
    'screen',
    'network',
    'events',
    'errors',
    'frustration_signal',
    'global_tags',
    'event_tags',
    'flow',
  ],
  ODP: ['custom'],
};
